import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import InstallPrompt from "@/components/InstallPrompt";

const STORAGE_KEY = "stjames.session";

function App() {
  const [session, setSession] = useState(null);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setSession(JSON.parse(raw));
    } catch (err) {
      console.warn("StJames: could not restore session", err);
    }
    setHydrated(true);
  }, []);

  const handleLogin = (member) => {
    setSession(member);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(member));
  };

  const handleLogout = () => {
    setSession(null);
    localStorage.removeItem(STORAGE_KEY);
  };

  if (!hydrated) return null;

  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#1A2F24",
            border: "1px solid #DCE0D9",
            borderRadius: "2px",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <InstallPrompt />
        <Routes>
          <Route
            path="/"
            element={
              session ? (
                <Navigate to="/home" replace />
              ) : (
                <Login onLogin={handleLogin} />
              )
            }
          />
          <Route
            path="/home"
            element={
              session ? (
                <Dashboard session={session} onLogout={handleLogout} onSessionUpdate={handleLogin} />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
